<template>
  <nav
    class="navbar navbar-expand-lg position-absolute top-0 z-index-3 w-100 shadow-none my-1 my-md-3  navbar-transparent ">
    <div class="container px-0">
      <a class="navbar-brand  text-white  d-none d-md-block" rel="tooltip" title="Cloud Raise Technology"
        data-placement="bottom" 
        href="javascript:;"
        @click.stop="goToPage('/')"
	>
        <img src="assets/img/logo1.svg" style="width: 160px;">
      </a>
      <a class="navbar-brand  text-white  d-block d-md-none" rel="tooltip" title="Cloud Raise Technology"
        data-placement="bottom"
        href="javascript:;"
        @click.stop="goToPage('/')"
	>
        <img src="assets/img/logo1.svg" style="width: 160px;">
      </a>
      <button class="navbar-toggler shadow-none ms-2 border-0" type="button" data-bs-toggle="collapse"
        data-bs-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon mt-2">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0" id="navigation">
        <ul class="navbar-nav navbar-nav-hover ms-auto">
          <li class="nav-item mx-3 mb-2 mb-md-0">
            <a class="nav-link ps-2 d-flex cursor-pointer align-items-center" 
	        href="javascript:;"
        	@click.stop="goToPage('/News')"
		>
              <i class="material-icons opacity-6 me-2 text-md">web</i>
              News<span class="ms-1">最新消息</span>
            </a>

          </li>
          <li class="nav-item dropdown dropdown-hover mx-3 mb-2 mb-md-0">
            <a class="nav-link ps-2 d-flex cursor-pointer align-items-center" 
	        href="javascript:;"
        	@click.stop="goToPage('/Company')"
		>
              <i class="material-icons opacity-6 me-2 text-md">account_tree</i>
              Company<span class="ms-1">公司簡介</span>
            </a>
          </li>
          <li class="nav-item dropdown dropdown-hover ms-3 me-4 mb-2 mb-md-0">
            <a class="nav-link ps-2 d-flex cursor-pointer align-items-center" 
	        href="javascript:;"
        	@click.stop="goToPage('/Products')"
		>
              <i class="material-icons opacity-6 me-2 text-md">shop</i>
              Products<span class="ms-1">產品介紹</span>
            </a>

          </li>
          <li class="nav-item dropdown dropdown-hover ms-3 me-4 mb-2 mb-md-0 d-lg-none">
            <a class="nav-link ps-2 d-flex cursor-pointer align-items-center" 
	        href="javascript:;"
        	@click.stop="goToPage('/Contact')"
		>
              <i class="material-icons opacity-6 me-2 text-md">mail</i>
              Contact<span class="ms-1">聯絡我們</span>
            </a>

          </li>

        </ul>
        <ul class="navbar-nav d-lg-block d-none">
          <li class="nav-item">
            <a class="btn btn-sm  bg-gradient-warning  mb-0 me-1"
	        href="javascript:;"
        	@click.stop="goToPage('/Contact')"
		>Contact Us</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

</template>
<script>
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line no-unused-vars
import { useI18n } from 'vue-i18n';
import { h, ref, reactive , watch , inject , onMounted , onUpdated} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { config , dev , oltConsole, oAA , oApiError , oAdminFrame, oAuth, oUserInfo} from '@/lib/oltModule/initAdminVue3';
import moment from 'moment' ;
//import { DotnetNav , PHPNav } from '@/components/Frame/NavMenu';
//import Loading from 'vue-loading-overlay';
//import 'vue-loading-overlay/dist/vue-loading.css';
import { useStore } from 'vuex';

export default {
  props: {
    /* eslint-disable vue/require-default-prop */
    showmode: String,
    tname: String,
    hiddenHeader:Boolean,
    routerBack:Boolean,
    routerName:String,
    routerTitle:String,
    rightbtnname: String,
    onright:Function,
    onleft:Function,
    rightbtnstatus: String,
    righttype: String
  },
  setup () {
    const { t, locale } = useI18n({
      useScope:'global' // 必需設定 SCOPE 才能覆蓋設定
    }); 

    locale.value = 'zh-TW';

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    function goToPage(page){
      router.push( { path: page } );
    }

    return {
      dev,
      config,
      // moment 
      moment,
      // i18n
      t,
      locale,      
      // record page
      fullPage: true,     
      // const data
      token:null,
      goToPage,
    };
  },
};
</script>

